import React from 'react';

import { useGlobal } from '../../../../api/hooks/useGlobal.hook';
import { ButtonVariantsEnum } from '../../../../utils/_enums/button-variants.enum';
import { MediaContentType } from '../../../../utils/_enums/image-content-type.enum';
import { creatokenPosterUrlResolver } from '../../../../utils/_helper/creatoken-posterUrl-resolver';
import { Button } from '../../../_shared/button/button';
import Media from '../../../_shared/media/media';
import { Spacer } from '../../../_shared/spacer/spacer';
import styles from './instance-detail-unlockable-image.module.scss';
import axios from 'axios';

export interface InstanceDetailUnlockableImageProps {
    imageUrl: string;
    name: string;
    contentType: MediaContentType;
    notDownloadable?: boolean;
    variantId: number;
    nameWithExtension?: boolean;
}

export const InstanceDetailUnlockableImage: React.FC<InstanceDetailUnlockableImageProps> = (props: InstanceDetailUnlockableImageProps) => {

    const data = useGlobal();

    const downloadUnlockable = async () => {
        let href;
        let downloadName;
        try {
            if (props.contentType === MediaContentType.PNG
                || props.contentType === MediaContentType.JPEG
                || props.contentType === MediaContentType.JPG) {
                const res = await axios.get(props.imageUrl, { responseType: 'blob' });
                href = URL.createObjectURL(res.data);
            } else {
                href = props.imageUrl;
            }
            const indexOfExtension = props.imageUrl.lastIndexOf('.');
            const extension = props.imageUrl.substring(indexOfExtension).toLowerCase();
            downloadName = props.name + extension;
        } catch {
            href = props.imageUrl;
        }
        const a = document.createElement('a');
        a.href = href;
        if (downloadName) {
            a.download = downloadName;
        }
        a.target = '_blank';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    }

    return (
        <div className={styles['unlockable-image']}>
            <div>
                <Media
                    classNameWrapper={styles['image-wrapper']}
                    className={styles['image']}
                    src={props.imageUrl}
                    objectFit={'contain'}
                    contentType={props.contentType}
                    posterUrl={creatokenPosterUrlResolver(props.variantId ?? -1)}
                    alt={props.name}/>
                <Spacer height='10px'/>
                {props.notDownloadable ? (
                    <Button
                        disabled
                        variant={ButtonVariantsEnum.SECONDARY_OUTLINED}
                    >
                        {data?.buttons?.download?.buttonText ?? ''}
                    </Button>
                ) : (
                    <Button variant={ButtonVariantsEnum.SECONDARY_OUTLINED} onClick={downloadUnlockable}>
                        {data?.buttons?.download?.buttonText ?? ''}
                    </Button>
                )}
            </div>
        </div>
    );
};
InstanceDetailUnlockableImage.defaultProps = { notDownloadable: false };
